import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../config/colores'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import ListadoCamionesEnTransitoDetalle from '../containers/ListadoCamionesEnTransitoDetalle'

export const COLUMNS_CAMIONES_EN_TRANSITO_TOTAL = [
  {
    name: 'fechaCupoCustom',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(new Date(f * 1000)).format('DD/MM/YY')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'data',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (entry) => {
        const value = entry.cantidadTotal
        const cereal = entry.cereal
        const fecha = moment(new Date(entry.fechaCupoCustom * 1000)).format('DD-MM-YYYY')
        const filtroInicial = [
          {
            name: 'cereal',
            filterList: [cereal]
          },
          {
            name: 'fecha',
            filterList: [fecha]
          }
        ]

        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title='Camiones en viaje'
              content={<ListadoCamionesEnTransitoDetalle filtroInicial={filtroInicial} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'cantidadAutodescargable',
    label: 'Autodesc.',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  }
]

export const COLUMNS_CAMIONES_EN_TRANSITO = [
  {
    name: 'fecha',
    label: 'Fecha de cupo',
    options: {
      filter: true,
      sort: true,
      filterList: [],
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'numero',
    label: 'Número',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'codigoCupo',
    label: 'Código de cupo',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'tipoCupo',
    label: 'Tipo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportadorRazonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupoRazonSocial',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'corredorCompradorRazonSocial',
    label: 'Corredor de cupo',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  }
]
